export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "en-US",
    "Messages": {
        "3": "3",
        "5": "5",
        "10": "10",
        "-": "-",
        "Aby dodawać użytkowników do wydarzenia musisz najpierw zapisać formularz.": "To add users to event, you must first save form.",
        "Aby dokument był widoczny, należy przypisać go do kategorii.": "For document to be visible, it must be assigned to category.",
        "Administracja": "Administration",
        "Administratorzy": "Administrators",
        "Adres": "Address",
        "Adres domenowy": "Domain address",
        "Adres e-mail potwierdzony": "Email address confirmed",
        "Adres panelu administracyjnego": "Administration panel address",
        "Adres strony": "Page address",
        "Adres strony do osadzenia": "Page address for embedding",
        "Adres URL": "URL address",
        "Adres url do pliku wideo": "url address for video file",
        "Akceptuj": "Accept",
        "Aktualności": "News",
        "Aktywne": "Active",
        "Aktywni": "Active",
        "Aktywuj przerwę techniczną w witrynie": "Enable maintenance break on site",
        "Ankieta przed i po szkoleniu": "Survey before and after training",
        "Anonimowy": "Anonymous",
        "anuluj": "cancel",
        "Anuluj": "Cancel",
        "Aranżacja alternatywna": "Alternative arrangement",
        "Aranżacja główna": "Main arrangement",
        "Archiwizuj": "Archive",
        "Archiwum": "Archive",
        "Artykuł": "Article",
        "Artykuł jest dostępny dla wszystkich użytkowników": "Article is available to all users",
        "Artykuły": "Articles",
        "Artykuły ze strony": "Articles from page",
        "Asystent AI": "AI Assistant",
        "Automatyczna publikacja galerii": "Automatic gallery publication",
        "Automatyczna publikacja wpisów": "Automatic entry publication",
        "Autor": "Author",
        "Autor został dodany.": "Author has been added.",
        "Autor został zaktualizowany.": "Author has been updated.",
        "Autorzy": "Authors",
        "Azure": "Azure",
        "Baza dokumentów": "Document database",
        "Bazowy model danych": "Base data model",
        "Bez \"http(s)://\" i \"/\" na końcu.": "Without \"http(s)://\" and trailing \"/\".",
        "Bez zdjęć": "Without photos",
        "Blokada konta do": "Account lock until",
        "Błąd w kolumnie ${error.columnName} w wierszu ${error.actualRow} - ${error.error}": "Error in column ${error.columnName} in row ${error.actualRow} - ${error.error}",
        "Brak": "None",
        "Brak artykułów": "No articles",
        "Brak dodanych plików": "No files added",
        "Brak działu nadrzędnego": "No parent section",
        "Brak etykiety": "No label",
        "Brak kategorii": "No category",
        "Brak kategorii nadrzędnej": "No parent category",
        "Brak modułu": "No module",
        "Brak odpowiedzi dla ankiety": "No answer for survey",
        "Brak plików do dodania": "No files to add",
        "Brak powiązań": "No relations",
        "Brak przypisanych zespołów": "No assigned teams",
        "Brak stron": "No pages",
        "Brak strony nadrzędnej": "No parent page",
        "Brak wybranych autorów": "No selected authors",
        "Brak wyników": "No results",
        "Cechy": "Features",
        "Chat w szkoleniu": "Chat in training",
        "CMS": "CMS",
        "co": "what",
        "Czas na slajd": "Time per slide",
        "Czas rozpoczęcia": "Start time",
        "Czas zakończenia": "End time",
        "Czołówka": "Lead",
        "Czołówka została dodana.": "Lead has been added.",
        "Czołówka została usunięta.": "Lead has been deleted.",
        "Czołówka została zaktualizowana.": "Lead has been updated.",
        "Czy na pewno chcesz wyczyścić pamięć podręczną?": "Are you sure you want to clear cache?",
        "Dalej": "Next",
        "Dane autoryzacyjne Google Analytics": "Google Analytics credentials",
        "Dane autoryzacyjne powinny być przekazane w formacie JSON, który można uzyskać z pliku autoryzacyjnego utworzonego z klucza dostępowego na platformie Google Cloud": "Credentials should be provided in JSON format, which can be obtained from authorization file created from access key on Google Cloud platform",
        "Dane z formularza zapisywane anonimowo": "Form data saved anonymously",
        "Data": "Date",
        "Data dezaktywacji": "Deactivation date",
        "Data do": "Date to",
        "Data do której jest wymagane potwierdzenie": "Date until confirmation is required",
        "Data do której jest wymagane potwierdzenie:": "Date until confirmation is required:",
        "Data dodania": "Date added",
        "Data końcowa": "End date",
        "Data modyfikacji": "Modification date",
        "Data modyfikacji:": "Modification date:",
        "Data od": "Date from",
        "Data ostatniego wpisu": "Date of last entry",
        "Data publikacji": "Publication date",
        "Data publikacji:": "Publication date:",
        "Data rejestracji": "Registration date",
        "Data rozpoczęcia": "Start date",
        "Data utworzenia": "Creation date",
        "Data ważności": "Expiry date",
        "Data ważności dokumentu": "Document expiry date",
        "Data wysłania": "Sent date",
        "Data zakończenia": "End date",
        "Data zgłoszenia": "Submission date",
        "Daty publikacji zostały zaktualizowane.": "Publication dates have been updated.",
        "DELETE: Usunięcie wpisu": "DELETE: Deleting entry",
        "Do akceptacji": "For approval",
        "Dodaj": "Add",
        "Dodaj czołówkę": "Add lead",
        "Dodaj dokument": "Add document",
        "Dodaj dział": "Add section",
        "Dodaj etykietę": "Add label",
        "Dodaj formularz": "Add form",
        "Dodaj galerię": "Add gallery",
        "Dodaj katalog": "Add catalog",
        "Dodaj kategorie": "Add categories",
        "Dodaj kategorię": "Add category",
        "Dodaj link": "Add link",
        "Dodaj lokalizację": "Add location",
        "Dodaj plik": "Add file",
        "Dodaj slajd": "Add slide",
        "Dodaj slajder": "Add slider",
        "Dodaj stanowisko": "Add position",
        "Dodaj stronę": "Add page",
        "Dodaj użytkownika": "Add user",
        "Dodaj wątek": "Add thread",
        "Dodaj wiadomość": "Add message",
        "Dodaj witrynę": "Add site",
        "Dodaj wpis": "Add entry",
        "Dodaj załącznik": "Add attachment",
        "Dodane pliki z sortowaniem": "Added files with sorting",
        "Dodane przez": "Added by",
        "Dodane przez moje zespoły": "Added by my teams",
        "Dodane przeze mnie": "Added by me",
        "Dodanie dokumentu": "adding document",
        "Dodanie działu": "adding section",
        "Dodanie galerii": "adding gallery",
        "Dodanie kategorii": "adding category",
        "Dodanie kategorii wydarzenia": "adding event category",
        "Dodanie lokalizacji": "adding location",
        "Dodanie slajdera": "adding slider",
        "Dodanie stanowiska": "adding position",
        "Dodanie strony": "adding page",
        "Dodanie wątku": "adding thread",
        "Dodanie wpisu": "adding entry",
        "Dodanie wydarzenia": "adding event",
        "Dodatki do e-learningu": "E-learning add-ons",
        "Dodatkowe parametry w adresie URL": "Additional parameters in URL address",
        "Dokument": "Document",
        "Dokument %0": "Document %0",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "Document has not been published anywhere yet.",
        "Dokument nie ma ustawionej daty publikacji.": "Document does not have publication date set.",
        "Dokument został dodany.": "Document has been added.",
        "Dokument został przywrócony z archiwum.": "Document has been restored from archive.",
        "Dokument został usunięty.": "Document has been deleted.",
        "Dokument został zaktualizowany.": "Document has been updated.",
        "Dokument został zarchiwizowany.": "Document has been archived.",
        "Dokumenty": "Documents",
        "Domyślna witryna": "Default site",
        "Domyślne ustawienie dla witryny": "Default setting for site",
        "Dostęp ": "Access ",
        "Dostęp do": "Access to",
        "Dostęp od": "Access from",
        "Dostęp został zmieniony.": "Access has been changed.",
        "Dostępne bloki": "Available blocks",
        "Dostępne dla": "Available for",
        "Dostępne dla wszystkich": "Available for all",
        "Dostępne języki": "Available languages",
        "Dostępne moduły": "Available modules",
        "Dostępne wersje językowe.": "Available language versions.",
        "Dostępy": "Accesses",
        "Dozwolone są tylko małe litery i znak -": "Only lowercase letters and - character are allowed",
        "Dział": "Section",
        "Dział można opublikować tylko na jednej stronie.": "Section can be published only on one page.",
        "Dział nadrzędny": "Parent section",
        "Dział został dodany.": "Section has been added.",
        "Dział został usunięty.": "Section has been deleted.",
        "Dział został zaktualizowany.": "Section has been updated.",
        "Działania masowe": "Bulk actions",
        "Działy": "Sections",
        "Dzienny": "Daily",
        "dzień": "day",
        "Dzień": "Day",
        "dzień (dni)": "day (days)",
        "Dzień miesiąca": "Day of month",
        "E-mail": "E-mail",
        "Edycja dokumentu": "edit document",
        "Edycja działów": "edit sections",
        "Edycja galerii": "edit gallery",
        "Edycja kategorii": "edit category",
        "Edycja kategorii wydarzenia": "edit event category",
        "Edycja lokalizacji": "edit location",
        "Edycja slajdera": "edit slider",
        "Edycja stanowiska": "edit position",
        "Edycja strony": "edit page",
        "Edycja wątku": "edit thread",
        "Edycja wpisu": "edit entry",
        "Edycja wydarzenia": "edit event",
        "Edytuj": "Edit",
        "Edytuj komentarz": "Edit comment",
        "Edytuj slajder": "Edit slider",
        "Edytuj stronę": "Edit page",
        "Eksport": "Export",
        "Email": "Email",
        "Email potwierdzony": "Email confirmed",
        "Etykieta": "Label",
        "Etykieta została dodana.": "Label has been added.",
        "Etykieta została usunięta.": "Label has been deleted.",
        "Etykieta została zaktualizowana.": "Label has been updated.",
        "Facebook": "Facebook",
        "Facebook Admins": "Facebook Admins",
        "Facebook Application ID": "Facebook Application ID",
        "FavIcona": "FavIcon",
        "Filtry": "Filters",
        "Formularz": "Form",
        "Formularz jest wymagany": "Form is required",
        "Formularz został utworzony.": "Form has been created.",
        "Forum": "Forum",
        "Galeria": "Gallery",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "Gallery has not been published anywhere yet.",
        "Galeria nie ma ustawionej daty publikacji.": "Gallery does not have publication date set.",
        "Galeria zdjęć": "Photo gallery",
        "Galeria została dodana.": "Gallery has been added.",
        "Galeria została usunięta.": "Gallery has been deleted.",
        "Galeria została zaktualizowana.": "Gallery has been updated.",
        "Gazetka": "Newsletter",
        "Generowanie raportu": "Generating report",
        "Generuj": "Generate",
        "Generuj raport": "Generate report",
        "Generuj streszczenia do plików": "Generate summaries for files",
        "Generuj wszystkie metadane": "Generate all metadata",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "GET: Entry list (sorting and pagination)",
        "GET: Pobranie danych": "GET: Retrieving data",
        "GET: Pobranie wpisu": "GET: Retrieving entry",
        "GET: Schemat (definicja formularza)": "GET: Schema (form definition)",
        "Google": "Google",
        "Google Maps": "Google Maps",
        "Hasło": "Password",
        "Hierarchiczny": "Hierarchical",
        "i posiadających wymagane uprawnienia": "and having required privileges",
        "Id": "Id",
        "ID": "ID",
        "Identyfikator usługi Google Analytics": "Google Analytics service identifier",
        "Ikona": "Icon",
        "Ikona jest wymagana": "Icon is required",
        "Ikona wyświetlana jest w postaci kwadratu.": "Icon is displayed as square.",
        "Ilość": "Quantity",
        "Ilość artykułów w kategorii": "Number of articles in category",
        "Ilość kolumn podkategorii": "Number of subcategory columns",
        "Ilość wydarzeń": "Number of events",
        "Ilość wyświetlanych artykułów": "Number of displayed articles",
        "Imię": "First name",
        "Imię i Nazwisko": "First and Last Name",
        "Imię i nazwisko/nazwa autora": "First and last name/author name",
        "Imię lub nazwisko": "First name or last name",
        "Import": "Import",
        "Import użytkowników": "Import users",
        "Indywidualny": "Individual",
        "Indywidualny z terminu spotkań": "Individual from meeting dates",
        "Informacja o błędzie": "Error information",
        "Informacja o ciasteczkach": "Cookie information",
        "Inspekcja": "Inspection",
        "Integracje": "Integrations",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "If user is not on list, it means basic data such as First and Last Name are missing. Complete this data in Users section.",
        "Język": "Language",
        "Język domyślny": "Default language",
        "Kalendarz": "Calendar",
        "Kanały": "Channels",
        "Katalog": "Catalog",
        "Katalog linków": "Link catalog",
        "Kategoria": "Category",
        "Kategoria jest wymagana": "Category is required",
        "Kategoria linku": "Link category",
        "Kategoria nadrzędna": "Parent category",
        "Kategoria nie jest jeszcze nigdzie opublikowana.": "Category has not been published anywhere yet.",
        "Kategoria wydarzenia": "Event category",
        "Kategoria została dodana.": "Category has been added.",
        "Kategoria została usunięta.": "Category has been deleted.",
        "Kategoria została zaktualizowana.": "Category has been updated.",
        "Kategorie": "Categories",
        "Kategorie wydarzeń": "Event categories",
        "Kategorię": "Category",
        "Kategorię można opublikować tylko na jednej stronie.": "Category can be published only on one page.",
        "Kod Bing Webmaster": "Bing Webmaster code",
        "Kod Google Webmaster": "Google Webmaster code",
        "Kod GTM": "GTM code",
        "Kolor": "Color",
        "Kolor tekstu": "Text color",
        "Kolor tła": "Background color",
        "Kolumny": "Columns",
        "Komentarz": "Comment",
        "Komentarz %0": "Comment %0",
        "Komentarze": "Comments",
        "Konfiguracja": "Configuration",
        "Konfiguruj stronę": "Configure page",
        "Koniec po": "End after",
        "Konto aktywne": "Active account",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "Account will remain inactive until email address is confirmed",
        "Konto z dostępem do panelu": "Account with panel access",
        "Konto zanonimizowane": "Anonymized account",
        "Kopiuj": "Copy",
        "Kreator modułu": "Module wizard",
        "Krótki opis": "Short description",
        "Krótki tytuł": "Short title",
        "Ldap": "Ldap",
        "Liczba ankiet": "Number of surveys",
        "Liczba dni od pierwszego logowania": "Number of days since first login",
        "Liczba dni od pierwszego logowania:": "Number of days since first login:",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "Number of slides visible to user cannot be greater than number of slides added in panel.",
        "Liczba wydarzeń": "Number of events",
        "Liczba wyników na stronie": "Number of results per page",
        "Liczba wyświetlanych slajdów": "Number of displayed slides",
        "Liczba zaimportowanych użytkowników: ${importInformations?.importedAccounts}": "Number of imported users: ${importInformations?.importedAccounts}",
        "Liczba zgłoszeń:": "Number of submissions:",
        "Lider/koordynator dla wszystkich zespołów": "Leader/coordinator for all teams",
        "Limit dodanych linków": "Limit of added links",
        "Link": "Link",
        "Link do strony": "Link to page",
        "Link został dodany.": "Link has been added.",
        "Link został usunięty.": "Link has been deleted.",
        "Link został zaktualizowany.": "Link has been updated.",
        "Lista artykułów": "Article list",
        "Lista jest pusta": "List is empty",
        "Lista linków": "Link list",
        "Lista propozycji użytkowników do oznaczenia": "List of suggested users to tag",
        "Lista wydarzeń": "Event list",
        "Logo": "Logo",
        "Lokalizacja": "Location",
        "Lokalizacja została dodana.": "Location has been added.",
        "Lokalizacja została usunięta.": "Location has been deleted.",
        "Lokalizacja została zaktualizowana.": "Location has been updated.",
        "Lokalizacje": "Locations",
        "Lokalizowane": "Localized",
        "Lokalne": "Local",
        "Ładowanie zgłoszeń...": "Loading submissions...",
        "Marketing": "Marketing",
        "Metadane": "Metadata",
        "mies.": "mo.",
        "miesiąc": "month",
        "Miesiąc": "Month",
        "Miesięczny": "Monthly",
        "Miniatura zdjęcia": "Photo thumbnail",
        "Model danych": "Data model",
        "Model danych i cechy można skonfigurować tylko podczas dodawania nowego formularza.": "Data model and features can be configured only when adding new form.",
        "Moduł": "Module",
        "Moduł dynamiczny": "Dynamic module",
        "Moduł spotkań": "Meetings module",
        "Moduł został dodany.": "Module has been added.",
        "Moduły": "Modules",
        "Moduły wyszukiwarki": "Search engine modules",
        "Moje dokumenty": "My documents",
        "Monitor kolejek": "Queue monitor",
        "Monitoring": "Monitoring",
        "Możliwość dodawania linków przez użytkownika": "Ability to add links by user",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "Ability to modify this account is limited. Inactive fields are sychronized with external database %0.",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "Ability to modify this account is limited. Inactive fields are synchronized with external database %0.",
        "Multimedia": "Multimedia",
        "Najwyższy poziom": "Top level",
        "Narzędzia": "Tools",
        "Nazwa": "Name",
        "Nazwa adresu": "Address name",
        "Nazwa certyfikatu": "Certificate name",
        "Nazwa czołówki": "Lead name",
        "Nazwa dokumentu": "Document name",
        "Nazwa działu": "Section name",
        "Nazwa etykiety": "Label name",
        "Nazwa formularza": "Form name",
        "Nazwa jest wymagana": "Name is required",
        "Nazwa kategorii": "Category name",
        "Nazwa Kategorii": "Category Name",
        "Nazwa linku": "Link name",
        "Nazwa lokalizacji": "Location name",
        "Nazwa modułu": "Module name",
        "Nazwa musi mieć co najmniej 4 znaki": "Name must be at least 4 characters",
        "Nazwa nie może być dłuższa niż 30 znaków": "Name cannot exceed 30 characters",
        "Nazwa pliku": "File name",
        "Nazwa sekcji w menu": "Section name in menu",
        "Nazwa slajdera": "Slider name",
        "Nazwa slajdu": "Slide name",
        "Nazwa stanowiska": "Position name",
        "Nazwa strony": "Page name",
        "Nazwa szablonu": "Template name",
        "Nazwa szkolenia": "Training name",
        "Nazwa użytkownika": "Username",
        "Nazwa użytkownika - intralearn": "Username - intralearn",
        "Nazwa w panelu": "Name in panel",
        "Nazwa wątku": "Thread name",
        "Nazwa witryny": "Site name",
        "Nazwa wyświetlana": "Display name",
        "Nazwa wyświetlana:": "Display name:",
        "Nazwa:": "Name:",
        "Nazwisko": "Last name",
        "Nie": "No",
        "Nie ma jeszcze żadnego działu.": "There is no section yet.",
        "Nie ma jeszcze żadnych kategorii.": "There are no categories yet.",
        "Nie ma jeszcze żadnych rekordów": "There are no records yet",
        "Nie masz uprawnień do zarządzania uprawnieniami": "You do not have privileges to manage privileges",
        "Nie można przypisać strony do działu, który nie jest działem głównym.": "Cannot assign page to section that is not main section.",
        "Nie można usunąć strony przypisanej do działu głównego.": "Cannot delete page assigned to main section.",
        "Nie można usunąć swojego konta.": "Cannot delete your own account.",
        "Nie udało się pobrać listy aranżacji": "Failed to retrieve arrangement list",
        "Nie udało się pobrać listy bloków": "Failed to retrieve block list",
        "Nie udało się pobrać listy działów": "Failed to retrieve section list",
        "Nie udało się pobrać listy etykiet": "Failed to retrieve label list",
        "Nie udało się pobrać listy kategorii": "Failed to retrieve category list",
        "Nie udało się pobrać listy lokalizacji": "Failed to retrieve location list",
        "Nie udało się pobrać listy modułów": "Failed to retrieve module list",
        "Nie udało się pobrać listy modułów wyszukiwarki": "Failed to retrieve search engine module list",
        "Nie udało się pobrać listy ról": "Failed to retrieve role list",
        "Nie udało się pobrać listy stanowisk": "Failed to retrieve position list",
        "Nie udało się pobrać listy stron": "Failed to retrieve page list",
        "Nie udało się pobrać listy szablonów": "Failed to retrieve template list",
        "Nie udało się pobrać listy zespołów do których jest przypisany użytkownik": "Failed to retrieve list of teams to which user is assigned",
        "Nie udało się ustawić aranżacji domyślnej": "Failed to set default arrangement",
        "Nie udało się załadować ankiet.": "Failed to load surveys.",
        "Nie wszystkie pola zostały wypelnione prawidłowo.": "Not all fields have been filled in correctly.",
        "Nie wybrano strony": "No page selected",
        "Nie zdefiniowano żadnych ról.": "No roles defined.",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Nieaktywne": "Inactive",
        "Nieaktywni": "Inactive",
        "Niepotwierdzeni": "Unconfirmed",
        "Niepubliczne": "Private",
        "Niestandardowy adres": "Custom address",
        "Niestandardowy adres strony": "Custom page address",
        "Nieudane logowania": "Failed logins",
        "Nowa kategoria": "New category",
        "Number": "Number",
        "Numer": "Number",
        "Numer komórkowy": "Mobile number",
        "Numer pracownika": "Employee number",
        "Numer telefonu": "Phone number",
        "Numer telefonu komórkowego": "Mobile phone number",
        "Odrzuć": "Reject",
        "Odznacz wszystkie": "Deselect all",
        "Ok": "Ok",
        "Okładka": "Cover",
        "Opcja pozwala na przypisywanie do tej kategorii wydarzeń dodanych przez wszystkich użytkowników": "Option allows assigning to this category events added by all users",
        "Opis": "Description",
        "Opis kategorii": "Category description",
        "Opis przerwy technicznej": "Maintenance break description",
        "Opublikowane": "Published",
        "Opublikowane języki": "Published languages",
        "Opublikowane wersje językowe.": "Published language versions.",
        "Opublikuj": "Publish",
        "Opublikuj autora": "Publish author",
        "Opublikuj dział": "Publish section",
        "Opublikuj wątek": "Publish thread",
        "Opublikuj wpis": "Publish entry",
        "Organizacja": "Organization",
        "Otwórz na nowej karcie": "Open in new tab",
        "Otwórz stronę w nowym oknie": "Open page in new window",
        "Otwórz w nowej karcie": "Open in new tab",
        "Pamięć podręczna": "Cache",
        "Pamięć podręczna została wyczyszczona.": "Cache has been cleared.",
        "Pełna treść:": "Full content:",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "First page from list is identified by system as CANONICAL, which informs search engine bots which of duplicated pages is one with original content.",
        "Plik": "File",
        "Plik wideo": "Video file",
        "Pliki": "Files",
        "Pliki do dodania": "Files to add",
        "Po aktywacji wejście na dowolną stronę frontową przez użytkownika w obrębie witryny wyświetli informację o trwającej przerwie technicznej. Witryna podczas przerwy technicznej dla użytkowników z uprawnieniami administratora jest zawsze dostępna.": "After activation, entering any frontend page by user within site will display information about ongoing maintenance break. Site during maintenance break is always available for users with administrator privileges.",
        "Po zapisaniu wydarzenia nie można zmienić witryny i wersji językowej": "After saving event, site and language version cannot be changed",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "After selecting this option, individual privileges and privileges inherited from roles are not taken into account.",
        "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "Enter Facebook user identifiers, separated by commas, so they can access statistics (Facebook Insights).",
        "Podaj nazwę formularza": "Enter form name",
        "Podgląd strony": "Page preview",
        "Podstawowe": "Basic",
        "Pojedynczy artykuł (strona opisowa)": "Single article (description page)",
        "Pokaż dla wybranych zespołów lub użytkowników": "Show for selected teams or users",
        "Pokaż listę wpisów": "Show entry list",
        "Pokaż wyniki z ostatnich dni": "Show results from recent days",
        "Pole \"Email\" jest wymagane.": "Field \"Email\" is required.",
        "Pole \"Język\" jest wymagane.": "Field \"Language\" is required.",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "Field \"Username\" is required.",
        "Pole \"Witryna\" jest wymagane.": "Field \"Site\" is required.",
        "Pole nie może zawierać spacji": "Field cannot contain spaces",
        "Polecenie dla asystenta AI": "Command for AI assistant",
        "Polubienia": "Likes",
        "Polubienia włączone": "Likes enabled",
        "POST: Dowolne wyszukiwanie (Zapytanie EQL)": "POST: Any search (EQL query)",
        "POST: Upload załączników": "POST: Attachment upload",
        "POST: Utworzenie wpisu": "POST: Creating entry",
        "POST: Zapisanie zmian": "POST: Saving changes",
        "Potwierdzenie archiwizacji": "Archive confirmation",
        "Potwierdzenie przywrócenia": "Restore confirmation",
        "Potwierdzenie przywrócenia z archiwum": "Restore from archive confirmation",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdzenie zatwierdzenia": "Approval confirmation",
        "Potwierdź akceptację": "Confirm approval",
        "Potwierdź usunięcie": "Confirm delete",
        "Powiadomienia dla użytkowników": "Notifications for users",
        "Powiadomienie zostało dodane do kolejki.": "Notification has been added to queue.",
        "Powiązane artykuły": "Related articles",
        "Powiązany artykuł": "Related article",
        "Powiązany autor": "Related author",
        "Powód": "Reason",
        "Powód odrzucenia": "Reason for rejection",
        "Powrót": "back",
        "Powtarzaj co": "Repeat every",
        "Powtórz hasło": "Repeat password",
        "Pozostałe": "Other",
        "Pozostałe ustawienia": "Other settings",
        "Pozycja": "Position",
        "Premium": "Premium",
        "Profil został zaktualizowany.": "Profile has been updated.",
        "Proste uprawnienia": "Simple privileges",
        "Przefiltrowani użytkownicy": "Filtered users",
        "Przerwa techniczna": "Maintenance break",
        "Przypomnienie": "Reminder",
        "Przywróć": "Restore",
        "Przywróć z archiwum": "Restore from archive",
        "Przywróć zaznaczone": "Restore selected",
        "Publiczne": "Public",
        "Publiczne ID:": "Public ID:",
        "Publikacja": "Publication",
        "Publikacja galerii przez użytkownika": "Gallery publication by user",
        "Publikacja wpisów przez użytkownika": "Entry publication by user",
        "Publikacja została dodana.": "Publication has been added.",
        "Publikacja została usunięta.": "Publication has been deleted.",
        "Publikuj do": "Publish until",
        "Publikuj na stronie": "Publish on page",
        "Publikuj na witrynie": "Publish on site",
        "Publikuj od": "Publish from",
        "PUT: Aktualizacja wpisu": "PUT: Updating entry",
        "Ranga": "Rank",
        "Raport został wygenerowany.": "Report has been generated.",
        "Regulaminy": "Terms and conditions",
        "Relacyjne": "Relational",
        "Rest API": "Rest API",
        "Roczny": "Yearly",
        "Rodzaj wydarzenia": "Event type",
        "rok": "year",
        "Rola": "Role",
        "Role użytkownika": "User roles",
        "Sekcja": "Section",
        "Sekcja %0": "Section %0",
        "Sekcja modułu": "Module section",
        "Skrypty zewnętrzne": "External scripts",
        "Skrypty związane ze zbieraniem danych targetujących, np. Google Tag Manager, Pixel Facebook. Dodawany w górnej części <body> witryny.": "Scripts related to collecting targeting data, e.g. Google Tag Manager, Facebook Pixel. Added in upper part of site <body>.",
        "Skrypty związane ze zbieraniem statystyk przez usługi zewnętrzne, np. Analytics, Matomo. Dodawany w górnej części <head> witryny.": "Scripts related to collecting statistics by external services, e.g. Analytics, Matomo. Added in upper part of site <head>.",
        "Slajder": "Slider",
        "Slajder został dodany.": "Slider has been added.",
        "Slajder został usunięty.": "Slider has been deleted.",
        "Slajder został zaktualizowany.": "Slider has been updated.",
        "Slajdery": "Sliders",
        "Sortowanie dokumentów": "Document sorting",
        "Sortowanie działów": "Section sorting",
        "Sortowanie kategorii": "Category sorting",
        "Sortowanie linków": "Link sorting",
        "Sortuj dokumenty": "Sort documents",
        "Sortuj kategorie": "Sort categories",
        "Sortuj linki": "Sort links",
        "Specjalizowane": "Specialized",
        "Standardowe uprawnienia": "Standard privileges",
        "Standardowy": "Standard",
        "Stanowiska": "Positions",
        "Stanowisko pracy": "Job position",
        "Stanowisko zostało dodane.": "Position has been added.",
        "Stanowisko zostało usunięte.": "Position has been deleted.",
        "Stanowisko zostało zaktualizowane.": "Position has been updated.",
        "Status": "Status",
        "Status dokumentu": "Document status",
        "Status dokumentu został zmieniony.": "Document status has been changed.",
        "Status galerii został zmieniony.": "Gallery status has been changed.",
        "Status linku został zmieniony.": "Link status has been changed.",
        "Status powiadomienia": "Notification status",
        "Status użytkownika": "User status",
        "Status:": "Status:",
        "Streszczenie dla pliku ' + f.fileName + ' zostało wygenerowane": "Summary for file ' + f.fileName + ' has been generated",
        "Strona": "Page",
        "Strona błędu": "Error page",
        "Strona deklaracja dostępności": "Accessibility declaration page",
        "Strona docelowa dla 'Kontakt z adminem'": "Target page for 'Contact admin'",
        "Strona docelowa dla 'Pliki cookies'": "Target page for 'Cookies files'",
        "Strona docelowa dla 'Polityka prywatności'": "Target page for 'Privacy policy'",
        "Strona dostępna dla wszystkich": "Page available for all",
        "Strona dostępna tylko dla zalogowanych użytkowników": "Page available only for logged-in users",
        "Strona nadrzędna": "Parent page",
        "Strona opublikowana": "Page published",
        "Strona ukryta": "Hidden page",
        "Strona z modułu konto użytkownika": "Page from user account module",
        "Strona została dodana.": "Page has been added.",
        "Strona została usunięta.": "Page has been deleted.",
        "Strona została zaktualizowana.": "Page has been updated.",
        "Strona/kategoria nadrzędna": "Parent page/category",
        "Symbol": "Symbol",
        "Symbol autora": "Author symbol",
        "Symbol jest wymagany": "Symbol is required",
        "Symbol modułu": "Module symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -": "Symbol can consist only of lowercase letters, digits and - character",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "Symbol can consist only of lowercase letters, digits and - character ",
        "Symbol musi mieć co najmniej 4 znaki": "Symbol must be at least 4 characters",
        "Symbol nie może być dłuższy niż 20 znaków": "Symbol cannot exceed 20 characters",
        "Symbol strony": "Page symbol",
        "Symbol w adresie URL": "Symbol in URL address",
        "Synchronizacja użytkowników": "User synchronization",
        "Synchronizuj": "Synchronize",
        "System": "System",
        "Szablon graficzny": "Graphic template",
        "Szablon importu": "Import template",
        "Szablon modułu": "Module template",
        "Szczegóły": "Details",
        "Szczegóły wpisu": "Entry details",
        "Szkic": "Draft",
        "Szkolenia": "Training",
        "Ta opcja dodaje użytkownika do wszystkich zespołów z zaznaczoną opcją Lidera i pozwala koordynatorowi widzieć wszystko w profilu koordynatora. Również do nowo utworzonych zespołów będzie  on ustawiał się jako Lider.": "This option adds user to all teams with Leader option selected and allows coordinator to see everything in coordinator profile. Also in newly created teams, he will be set as Leader.",
        "Tagi": "Tags",
        "Tak": "Yes",
        "Ten element nie zawiera menu kontekstowego.": "This element does not contain context menu.",
        "Termin cykliczny": "Recurring date",
        "Termin jednorazowy": "One-time date",
        "Terminy": "Dates",
        "Tło w widoku logowania": "Background in login view",
        "Tokeny": "Tokens",
        "Treść": "Content",
        "Treść komentarza": "Comment content",
        "Treść wpisu": "Entry content",
        "Tryb wyświetlania": "Display mode",
        "tydzień (tygodnie) w następującym dniu": "week (weeks) on following day",
        "Tygodniowy": "Weekly",
        "Tylko aktualne": "Current only",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "Lowercase letters only, without special characters, digits and spaces.",
        "Tylko przeterminowane": "Expired only",
        "Tylko treść": "Content only",
        "Tylko zarchiwizowane": "Archived only",
        "Tylko ze zdjęciami": "With photos only",
        "Typ konta": "Account type",
        "Typ obiektu:": "Object type:",
        "Typ strony": "Page type",
        "Typ wyboru ikony": "Icon selection type",
        "Typ wyświetlanych artykułów": "Type of displayed articles",
        "Tytuł": "Title",
        "Tytuł przerwy technicznej": "Maintenance break title",
        "Tytuł strony": "Page title",
        "Tytuł witryny": "Site title",
        "Ukryj godzinę wydarzenia": "Hide event time",
        "Uprawnienia": "privileges",
        "URL": "URL",
        "Ustaw kategorię": "Set category",
        "Ustaw również dla wszystkich podstron": "Set also for all subpages",
        "Ustawienia": "Settings",
        "Ustawienia dostępności": "Accessibility settings",
        "Ustawienia generowania streszczeń": "Summary generation settings",
        "Ustawienia konta": "Account settings",
        "Ustawienia polubień": "Like settings",
        "Ustawienia slajdera": "Slider settings",
        "Ustawienia strony": "Page settings",
        "Ustawienia witryny": "Site settings",
        "Ustawienia zostały zaktualizowane.": "Settings have been updated.",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nCzy na pewno chcesz usunąć wybrany formularz?": "Deleting formnnOperation is irreversible. All related documents will be lost!nAre you sure you want to delete selected form?",
        "Usuń": "delete",
        "Usuń artykuł z listy": "Delete article from list",
        "Usuń autora": "Delete author",
        "Usuń plik": "Delete file",
        "Usuń powiązanie": "Delete relation",
        "Usuń slajd": "Delete slide",
        "Usuń stronę": "Delete page",
        "Usuń zaznaczone": "Delete selected",
        "Utwórz formularz": "Create form",
        "Uzasadnij odrzucenie": "Justify rejection",
        "Użytkownik": "User",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "User will not receive any notifications.",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "User cannot log in until account is active.",
        "Użytkownik posiada pełne uprawnienia": "User has full privileges",
        "Użytkownik zalogowany": "Logged-in user",
        "Użytkownik został dodany.": "User has been added.",
        "Użytkownik został usunięty.": "User has been deleted.",
        "Użytkownik został zaktualizowany.": "User has been updated.",
        "Użytkowników": "Users",
        "W następującym dniu:": "On following day:",
        "Wątek został dodany.": "Thread has been added.",
        "Wątek został usunięty.": "Thread has been deleted.",
        "Wątek został zaktualizowany.": "Thread has been updated.",
        "Wątki": "Threads",
        "Wersje": "Versions",
        "Wersjonowany": "Versioned",
        "Wideo": "Video",
        "Widoczna dla wszystkich użytkowników": "Visible to all users",
        "Widoczność konta": "Account visibility",
        "Wiersz ${error.actualRow}: błąd w kolumnie ${error.columnName} - ${error.error}": "Row ${error.actualRow}: error in column ${error.columnName} - ${error.error}",
        "Witryna aktywna": "Site active",
        "Witryna domyślna": "Default site",
        "Witryna i język": "Site and language",
        "Witryna tylko dla zalogowanych użytkowników": "Site only for logged-in users",
        "Witryna została dodana.": "Site has been added.",
        "Witryna została usunięta.": "Site has been deleted.",
        "Witryna została zaktualizowana.": "Site has been updated.",
        "Właściwości": "Properties",
        "Włącz ankietę": "Enable survey",
        "Włącz formularz": "Enable form",
        "Włączenie obsługi cacheu dla witryny": "Enable cache support for site",
        "Włączenie protokołu SSL dla tej witryny": "Enable SSL protocol for this site",
        "Wpis do kalendarza został usunięty.": "Calendar entry has been deleted.",
        "Wpis został dodany.": "Entry has been added.",
        "Wpis został usunięty.": "Entry has been deleted.",
        "Wpis został zaakceptowany.": "Entry has been approved.",
        "Wpis został zaktualizowany.": "Entry has been updated.",
        "Wpisy": "Entries",
        "Wpisy zostały usunięte.": "Entries have been deleted.",
        "Wpisy zostały zaakceptowane.": "Entries have been approved.",
        "Wstecz": "Back",
        "Wstęp": "Introduction",
        "Wszyscy użytkownicy": "All users",
        "Wszystkie": "All",
        "Wszystkie kategorie": "All categories",
        "Wszystko": "Everything",
        "Wybierz ankietę": "Select survey",
        "Wybierz artykuł": "Select article",
        "Wybierz autora": "Select author",
        "Wybierz formularz": "Select form",
        "Wybierz istniejącego użytkownika": "Select existing user",
        "Wybierz kategorię": "Select category",
        "Wybierz kategorię dokumentu.": "Select document category.",
        "Wybierz kategorię linku.": "Select link category.",
        "Wybierz przełożonego": "Select supervisor",
        "Wybierz stronę": "Select page",
        "wybierz szablon": "select template",
        "Wybierz szkolenie": "Select training",
        "Wybierz użytkownika": "Select user",
        "wybierz...": "select...",
        "Wybór dokumentów": "Document selection",
        "Wybór kategorii wydarzeń": "Event category selection",
        "Wybór osób": "People selection",
        "Wybór z listy": "Selection from list",
        "Wybrana ikona powinna być kwadratem": "Selected icon should be square",
        "Wybrane szkolenie nie jest opublikowane": "Selected training is not published",
        "Wybranie modułu jest wymagane": "Selecting module is required",
        "Wybranie sekcji jest wymagane": "Selecting section is required",
        "Wybranie strony jest wymagane": "Selecting page is required",
        "Wybrano": "Selected",
        "Wybrany szablon": "Selected template",
        "Wyczyszczenie pamięci podręcznej może spowodować usunięcie niezapisanych postępów czasu spędzonego na platformie.": "Clearing cache may cause removal of unsaved progress of time spent on platform.",
        "Wyczyść pamięć podręczną": "Clear cache",
        "Wydarzenie dostępne tylko w module spotkań": "Event available only in meetings module",
        "Wygląd": "Appearance",
        "Wyłącz komentarze dla tego artykułu": "Disable comments for this article",
        "Wyłącz udostępnij dalej": "Disable share forward",
        "Wyłączone wysyłanie powiadomień": "Notification sending disabled",
        "Wymaga potwierdzenia": "Requires confirmation",
        "Wymaga potwierdzenia do podanej daty": "Requires confirmation until specified date",
        "Wymaga potwierdzenia od pierwszego logowania": "Requires confirmation from first login",
        "Wymuś zmianę hasła": "Force password change",
        "wystąpieniach": "occurrences",
        "Wystąpił błąd podczas próby exportu użytkowników.": "An error occurred while exporting users.",
        "Wystąpił błąd podczas próby importu użytkowników.": "An error occurred while importing users.",
        "Wystąpił błąd podczas próby pobrania szablonu.": "An error occurred while retrieving template.",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "There are errors in form. Check all form fields.",
        "Wyszukaj": "Search",
        "Wyszukaj autora...": "Search author...",
        "Wyszukaj użytkownika...": "Search user...",
        "Wyślij powiadomienie e-mail": "Send email notification",
        "Wyślij powiadomienie o aktualizacji dokumentu": "Send notification about document update",
        "Wyświetl w ulubionych": "Display in favorites",
        "Wyświetlaj na stronie głównej": "Display on home page",
        "Wyświetlaj tylko treść": "Display content only",
        "Wyświetlaj zdjęcie na stronie głównej ": "Display photo on home page ",
        "wyświetleń": "views",
        "Wzorzec cyklu": "Cycle pattern",
        "z": "from",
        "Zaakceptowany": "Approved",
        "Zaawansowane uprawnienia": "Advanced privileges",
        "zacznij pisać aby wyszukać ankiety...": "start typing to search surveys...",
        "zacznij pisać aby wyszukać artykuł...": "start typing to search article...",
        "zacznij pisać aby wyszukać autora...": "start typing to search author...",
        "zacznij pisać aby wyszukać przełożonego...": "start typing to search supervisor...",
        "zacznij pisać aby wyszukać szkolenie...": "start typing to search training...",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search user...",
        "Zaimportowano listę użytkowników.": "User list has been imported.",
        "Zakres cyklu": "Cycle range",
        "Załączniki": "Attachments",
        "Zamknij": "Close",
        "Zamknij i pobierz": "Close and download",
        "Zapisz": "Save",
        "Zapisz artykuł, aby móc zarządzać uprawnieniami": "Save article to manage privileges",
        "Zapisz i wróć": "Save and go back",
        "Zastępstwa": "Substitutions",
        "Zatwierdź": "Approve",
        "Zatwierdź zaznaczone": "Approve selected",
        "Zaznacz wszystkie": "Select all",
        "Zaznaczone": "Selected",
        "Zaznaczone (${checkedItems.value.length})": "Selected (${checkedItems.value.length})",
        "Zdjęcie": "Photo",
        "Zdjęcie autora": "Author photo",
        "Zdjęcie dla tabletów": "Photo for tablets",
        "Zdjęcie dla urządzeń mobilnych": "Photo for mobile devices",
        "Zdjęcie główne": "Main photo",
        "Zdjęcie użytkownika": "User photo",
        "Zdjęcie/ikonka": "Photo/icon",
        "Zespoły": "Teams",
        "Zespoły użytkownika": "User teams",
        "Zespół": "Team",
        "Zewnętrzne skrypty statystyk": "External statistics scripts",
        "Zewnętrzne skrypty targetujące": "External targeting scripts",
        "Zgłoszenia": "Requests",
        "Zmiana symbolu powoduje również zmianę adresu URL.": "Changing symbol also changes URL address.",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmień daty publikacji": "Change publication dates",
        "Zobacz wszystkich użytkowników": "View all users",
        "Zobacz wszystkie artykuły": "View all articles",
        "Zobacz wszystkie galerie": "View all galleries",
        "Zwrócony": "Returned",
        "Źródło": "Source",
        "Źródło URL": "Source URL"
    }
};
